var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import omit from 'omit.js';
import React, { useMemo, useCallback } from 'react';
import { EventInjector } from 'react-event-injector';
import { createPrefixCls } from '../_utils/string';
import { Icon } from '../icon';
const prefixCls = createPrefixCls('toast');
const renderIcon = (icon) => {
    if (typeof icon === 'string') {
        if (icon.match(/(https?:)?\/\//gi) || icon.match(/\.(png|jpe?g|gif|webp|bpm|svg)$/gi)) {
            return (React.createElement("div", { className: prefixCls('image') },
                React.createElement("img", { src: icon })));
        }
        else {
            return (React.createElement("div", { className: prefixCls('icon') },
                React.createElement(Icon, { name: icon })));
        }
    }
    else if (React.isValidElement(icon)) {
        return React.createElement("div", { className: prefixCls('custom') }, icon);
    }
};
export const Toast = (_a) => {
    var { className, text, icon, mask = true, nowrap } = _a, restProps = __rest(_a, ["className", "text", "icon", "mask", "nowrap"]);
    const toastCls = useMemo(() => {
        return classnames([prefixCls(), className]);
    }, [className]);
    const containerCls = useMemo(() => {
        return classnames([prefixCls('container'), { [prefixCls('nowrap')]: nowrap }]);
    }, [nowrap]);
    const handlePreventDefault = useCallback((e) => {
        e.preventDefault();
    }, []);
    const _restProps = useMemo(() => {
        return omit(restProps, ['delay']);
    }, [restProps]);
    return (React.createElement(EventInjector, { settings: { passive: false }, onTouchMove: handlePreventDefault },
        React.createElement("div", Object.assign({ className: toastCls }, _restProps),
            mask && React.createElement("div", { className: prefixCls('mask') }),
            React.createElement("div", { className: containerCls },
                icon && renderIcon(icon),
                React.createElement("div", { className: prefixCls('text') }, text)))));
};
export default Toast;
